import { useNavigate } from "react-router-dom";
import { articles } from "@/mocks/articles";

interface Props {
  relatedIds: string[];
  currentId: string;
}

export default function RelatedArticles({ relatedIds, currentId }: Props) {
  const navigate = useNavigate();
  const related = articles.filter(
    (a) => relatedIds.includes(a.id) && a.id !== currentId
  );

  if (related.length === 0) return null;

  return (
    <section className="py-16 border-t border-[#e8e0d5]">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-8 h-px bg-[#8b6f47]"></span>
          <span
            className="text-[#8b6f47] text-[1rem] tracking-[0.3em] font-medium"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            延伸閱讀
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {related.map((article) => (
            <div
              key={article.id}
              className="group flex gap-4 cursor-pointer p-5 rounded-xl hover:bg-[#f5f0e8] transition-colors"
              onClick={() => {
                navigate(`/knowledge/${article.id}`);
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src={article.coverImg}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex-1 min-w-0">
                <span
                  className="text-[0.875rem] font-medium mb-1 block"
                  style={{
                    color: article.tagColor,
                    fontFamily: "'Noto Serif TC', serif",
                  }}
                >
                  {article.tag}
                </span>
                <h4
                  className="text-[#2d2520] font-semibold leading-[1.45] group-hover:text-[#8b6f47] transition-colors line-clamp-2"
                  style={{
                    fontSize: "1.1875rem",
                    fontFamily: "'Noto Serif TC', serif",
                  }}
                >
                  {article.title}
                </h4>
                <p
                  className="text-[#a89880] text-[1rem] mt-1"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  {article.readTime}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
